export const classes = {
  listItem:
    'rounded-2xl cursor-pointer text-sm px-6 py-3 mb-2 transition-colors select-none place-between',
  inactive:
    'bg-grey-2 dark:bg-white/[0.06] hover:bg-grey-3 dark:hover:bg-white/[0.1] text-grey-8 dark:text-mauve-1',
  active:
    'bg-orange-1/30 text-orange-3 font-medium tracking-wide text-base pr-3 cursor-default py-2',
  icon: 'text-orange-3',
};
